// extracted by mini-css-extract-plugin
module.exports = {"main":"main--uSixr","banner":"banner--w3ExJ","icon":"icon--rNfs7","icon-item":"icon-item--IXlXh"};